<template>
<div class="chapter">
<div class="inner_page">
<div class="copyrightPage" id="copyrightPage">
<p class="copyrightTextH">Published by</p>
<p class="copyrightText">Grub Street</p>
<p class="copyrightText">4 Rainham Close</p>
<p class="copyrightText">London</p>
<p class="copyrightText">SW11 6SS</p>
<p class="copyrightText1">Copyright © Grub Street 2010</p>
<p class="copyrightText">Copyright text © Wolfgang Fischer and John Weal 2010</p>
<p class="copyrightText2"><em class="italic">British Library Cataloguing in Publication Data</em></p>
<p class="copyrightText3">Fischer, Wolfgang.</p>
<p class="copyrightText3">Luftwaffe fighter pilot: defending the Reich against the RAF and USAAF.</p>
<p class="copyrightText3">1. Fischer, Wolfgang. 2. Germany. Luftwaffe--History.</p>
<p class="copyrightText3">3. World War, 1939-1945--Personal narratives, German.</p>
<p class="copyrightText3">4. World War, 1939-1945--Aerial operations, German.</p>
<p class="copyrightText3">5. Fighter pilots--Germany--Biography.</p>
<p class="copyrightText3">I. Title</p>
<p class="copyrightText3">940.5'44943'092-dc22</p>
<p class="copyrightText1"><em class="italic">ISBN-13: 9781906502836</em></p>
<p class="copyrightText">eISBN-13: 978-1-908117-98-4</p>
<p class="copyrightTextH1">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means electronic, mechanical, photocopying, recording or otherwise, without the prior permission of the copyright owner.</p>
<p class="copyrightText1">Cover design and typesetting by Sarah Driver</p>
<p class="copyrightText">Edited by Sophie Campbell</p>
<p class="copyrightText">Printed and bound by MPG Ltd, Bodmin, Cornwall</p>
<p class="copyrightText1">Grub Street Publishing only uses</p>
<p class="copyrightText">FSC (Forest Stewardship Council) paper for its books.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// LuftwaffeFighterPilot_copyright.vue?72f00ec1